import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaUnknownNode } from './TypedNode'
import { SchemaUnknownModel } from './ViewModel'

export const SchemaUnknownPlugin = createSchemaPlugin(
  'Schema.Unknown',
  SchemaUnknownModel,
  SchemaUnknownNode
)
